module.exports = __webpack_public_path__ + "static/img/icon-insurance-02.2b0ba9e7.png";